import type { SVGProps } from 'react';

interface UncollapseIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function UncollapseIcon({ className, ...props }: UncollapseIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="4.5 5.5 15.0 13.0"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path d="M17.6452 17.3333C17.6452 17.7015 17.9485 18 18.3226 18C18.6967 18 19 17.7015 19 17.3333L19 6.66667C19 6.29848 18.6967 6 18.3226 6C17.9485 6 17.6452 6.29848 17.6452 6.66667L17.6452 17.3333ZM5.67742 11.3333C5.30329 11.3333 5 11.6318 5 12C5 12.3682 5.30329 12.6667 5.67742 12.6667L13.6336 12.6667L11.0403 15.1597C10.7728 15.417 10.7675 15.8391 11.0289 16.1024C11.2903 16.3658 11.7191 16.3701 11.9868 16.1128L15.7699 12.4766C15.9002 12.3511 15.9737 12.1794 15.9737 12C15.9737 11.8206 15.9002 11.6489 15.7699 11.5234L11.9868 7.88715C11.7191 7.62988 11.2903 7.6342 11.0289 7.89757C10.7675 8.16092 10.7728 8.58299 11.0403 8.84028L13.6336 11.3333L5.67742 11.3333Z" fill="currentColor"/>
    </svg>
  );
}
